export const LRStyle = {
	locationStyle: {
		fontSize: '16px',
	},
	titleTextStyle: {
		fontSize: '16px',
	},
};
